<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      @selectField="onSelectField"
    />

    <!--    사업장 개요-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 사업장 개요</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사업금액</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.fieldInfo.deposit_amount }}</p>
        <ml-input
          v-else
          v-model="form.fieldInfo.deposit_amount"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장소장</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.fieldInfo.director_name }}</p>
        <ml-input
          v-else
          v-model="form.fieldInfo.director_name"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">안전관리자</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.fieldInfo.safety_manager_name }}</p>
        <ml-input
          v-else
          v-model="form.fieldInfo.safety_manager_name"
          class="w-full flex-1"
          :readonly="true"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">착공일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.fieldInfo.start_work_at }}
        </p>
        <date-selector
          v-else
          :readonly="true"
          class="w-full flex-1"
          v-model="form.fieldInfo.start_work_at"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">준공일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.fieldInfo.be_completed_at }}
        </p>
        <date-selector
          v-else
          :readonly="true"
          class="w-full flex-1"
          v-model="form.fieldInfo.be_completed_at"
        />
      </div>
    </div>

<!--    점검 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputC_1 }}
        </p>
        <date-selector
          v-else
          :readonly="board.readonly"
          class="w-full flex-1"
          v-model="form.inputC_1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검장소</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">재해형태(지적사항)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_3 }}</p>
        <disaster-class-selector
          v-else
          class="w-full flex-1"
          :readonly="board.readonly"
          v-model="form.inputC_3"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">서류점검</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_4"
          class="w-full flex-1"
        />
        <p class="ml-3">점</p>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">현장점검</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_5 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_5"
          class="w-full flex-1"
        />
        <p class="ml-3">점</p>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">총점</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_6"
          class="w-full flex-1"
        />
        <p class="ml-3">점 /100점</p>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검자(안전점검팀)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_7 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_7"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">수검자(안전관리자)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_8 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_8"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">확인자(현장소장)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_9 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_9"
          class="w-full flex-1"
        />
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">점검개요</div>
        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_10 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_10"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'

export default {
  components: {
    DisasterClassSelector,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onSelectField(data) {
      console.log(data);
      this.form.fieldInfo.deposit_amount = data.deposit_amount; // 사업금액
      this.form.fieldInfo.director_name = data.director_name;// 현장소장
      this.form.fieldInfo.safety_manager_name = data.safety_manager_name;// 안전관리자
      this.form.fieldInfo.start_work_at = data.start_work_at; // 착공일
      this.form.fieldInfo.be_completed_at = data.be_completed_at; //준공일
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        fieldInfo: {
          deposit_amount: "",
          director_name: "",
          safety_manager_name: "",
          start_work_at: "",
          be_completed_at: "",
        },

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
